import Boot from 'models/location/boot';
import UserLogin from 'models/location/user_login';

export default class OpenLogin {
  constructor(context) {
    this.context = context;
  }

  run(preAuthExternalPath) {
    if (this.context.stores.auth.get().isLoggedIn()) {
      const returnPath = this.isSsoReturn() && sameSitePath(preAuthExternalPath);
      if (returnPath) {
        this.context.router.navigateToPath(returnPath);
      } else {
        this.context.router.navigateHome();
      }
      return;
    }

    let preAuthPath;
    if (preAuthExternalPath) {
      preAuthPath = { path: preAuthExternalPath, external: true };
    } else {
      let requestedPath = this.context.stores.currentLocation.get().requestedPath;
      preAuthPath = requestedPath ? { path: requestedPath, external: false } : undefined;
    }
    this.context.stores.currentLocation.set(UserLogin.create({ preAuthPath }));
  }

  // Single sign-on returns a signed-out person to /user/login?fromPath=..., and
  // the app signs them in from the SSO cookie as the page loads, before this
  // runs. Someone already signed in when the page loaded still goes home: the
  // admin app sends them here when a call or a subscription is refused, and
  // sending them back would send them round again.
  isSsoReturn() {
    const location = this.context.stores.currentLocation.get();
    return location instanceof Boot && location.isFromSso;
  }
}

// The path of fromPath, or nothing when it names another site, such as
// //evil.example, or leads back to the login page.
function sameSitePath(path) {
  if (!path) {
    return undefined;
  }

  let url;
  try {
    url = new URL(path, window.location.origin);
  } catch (e) {
    return undefined;
  }

  if (url.origin !== window.location.origin || url.pathname.startsWith('/user/login')) {
    return undefined;
  }
  return url.pathname;
}
